module.exports = __webpack_public_path__ + "static/media/info-error.f12d1884.svg";